module.exports = __webpack_public_path__ + "img/image25.5fafc770.png";